import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.scss';
import logoCpay from '../../img/footer/footerLogo.svg';
import logoPayblock from '../../img/footer/payblock-logo.png';
import logoNfg from '../../img/nfgpay-svg/nfg_logo_black.svg';
import logoFinvaro from '../../img/finvaro/finvaro-logo-black.png';
import logoClarnium from '../../img/clarnium/clarnium-logo-color.png';
import logoInex from '../../img/inex/inex-logo.svg';
import logoInsta from '../../img/instaXchange/instaXchange-logo.png';
import logoCoinera from '../../img/coinera/coinera-logo.png';
import { identity } from '../../utils/getIdentity';
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";

const logos = {
  cpay: !AppConfig?.hideLogo ? logoCpay : logoPayblock,
  nfg: logoNfg,
  finvaro: logoFinvaro,
  clarnium: logoClarnium,
  inex: logoInex,
  insta: logoInsta,
  coinera: logoCoinera
}

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className={`not-found not-found-${identity}`}>
      <div className={`not-found__box not-found__box-${identity}`}>
        <div className={`not-found__header not-found__header-${identity}`}>
          <Link to="/">
            <img className={`${AppConfig?.hideLogo && 'not-found__header--logo'}`} src={logos[identity]} alt="logo" />
          </Link>
        </div>
        <div className="not-found__main-block">
          <span>404</span>
          <div className={`not-found__main-block-text not-found__main-block-text-${identity}`}>
            <h3>{t('admin.not_found')}</h3>
            <p>
              {t('admin.check_link')}
            </p>
          </div>
          <Link className={`not-found__button not-found__button-${identity}`} to="/">
            {t('admin.back_to_home')}
          </Link>
        </div>
      </div>
    </div>
  )
};

export default PageNotFound;